<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>任务管理</el-breadcrumb-item>
          <el-breadcrumb-item>任务实做人员明细</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageSerch">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span class="cardTitle">任务实做人员明细</span>
          </div>
          <el-form ref="ruleForm" :model="ruleForm">
            <el-row :gutter="24">
              <el-col :span="6">
                <el-form-item>
                  <el-input
                    maxlength="50"
                    clearable
                    v-model="ruleForm.name"
                    placeholder="请输入保安姓名"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item>
                  <el-input
                    maxlength="50"
                    clearable
                    v-model="ruleForm.phone"
                    placeholder="请输入保安手机号"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item label="状态">
                  <el-select
                    style="margin-right: auto"
                    v-model="ruleForm.status"
                    placeholder="请选择工作状态"
                  >
                    <el-option label="未开始" value="1"></el-option>
                    <el-option label="工作中" value="2"></el-option>
                    <el-option label="已完成" value="3"></el-option>
                    <el-option label="已结算" value="4"></el-option>
                    <el-option label="已取消" value="5"></el-option>
                    <el-option label="已开除(未结算)" value="6"></el-option>
                    <el-option label="已开除(已结算)" value="7"></el-option>
                    <el-option label="已取消已结算" value="8"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item>
                  <el-button type="primary" @click="getList()" class="btn"
                    >查询</el-button
                  >
                  <el-button @click="resetForm()">重置</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </div>
      <div class="pageTab">
        <el-button type="primary" @click="exportList(1)" class="btn"
          >实做保安明细导出</el-button
        >
        <el-button type="primary" @click="exportList()" class="btn"
          >实做保安考勤明细导出</el-button
        >
        <div class="pageInfo">
          <div style="margin-top: 10px">任务名称：{{ pageData.title }}</div>
          <div class="dis">
            <div>任务需求人数：{{ pageData.membersNum }}人</div>
            <div>身高：{{ pageData.highName }}</div>
          </div>
          <div class="dis">
            <div>任务单价：{{ pageData.unitPrice }}</div>
            <div>年龄：{{ pageData.ageTypeName }}</div>
          </div>
          <div class="dis">
            <div>服务时长：{{ pageData.serviceTimeStr }}</div>
            <div>着装：{{ pageData.dressTypeName }}</div>
          </div>
          <div style="margin-top: 10px">
            任务开始/结束时间：{{ pageData.jobStart }}-{{ pageData.jobEnd }}
          </div>
          <div style="margin-top: 10px">任务地址：{{ pageData.address }}</div>
        </div>
        <el-table
          :data="tableData"
          style="width: 100%; margin-top: 20px"
          @selection-change="handleSelectionChange"
          tooltip-effect="dark"
          ref="multipleTable"
        >
          <el-table-column type="selection" width="55" align="center">
          </el-table-column>
          <el-table-column
            prop="jobNo"
            label="任务编号"
            align="center"
            width="200"
          >
          </el-table-column>
          <el-table-column label="任务名称" align="center" width="180">
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top">
                {{ scope.row.title }}
                <div slot="reference" class="name-wrapper">
                  <div class="omit">{{ scope.row.title }}</div>
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column
            prop="bodyguardName"
            label="保安姓名"
            align="center"
            width="180"
          >
          </el-table-column>
          <el-table-column label="实际服务时长" align="center" width="120">
            <template slot-scope="scope">
              {{ scope.row.workedTimeStr }}
            </template>
          </el-table-column>
          <el-table-column label="补偿服务时长" align="center" width="190">
            <template slot-scope="scope">
              <div>{{ scope.row.extraSettledMinutesStr }}</div>
            </template>
          </el-table-column>
          <el-table-column label="预期收益" align="center" width="100">
            <template slot-scope="scope">
              <span>￥{{ scope.row.expectedIncome | moneyFormat }}</span>
            </template>
          </el-table-column>
          <el-table-column label="实际收益" align="center" width="100">
            <template slot-scope="scope">
              <span>￥{{ scope.row.actualSecIncome | moneyFormat }}</span>
            </template>
          </el-table-column>
          <el-table-column label="服务扣款" align="center" width="100">
            <template slot-scope="scope">
              <span>￥{{ scope.row.deduction | moneyFormat }}</span>
            </template>
          </el-table-column>

          <el-table-column label="状态" align="center" width="100">
            <template slot-scope="scope">
              <span class="blueColor">{{ scope.row.workStatusName }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
            fixed="right"
            width="120"
          >
            <template slot-scope="scope">
              <div class="disAround">
                <div class="operateBtn" @click="goDetail1(scope.row)">
                  查看考勤
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="total, prev, pager, next,sizes"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import system from "../../components/system_left.vue";
export default {
  components: {
    system,
  },
  data() {
    return {
      leftList: this.Plugins.taskData(),
      ruleForm: {
        name: "",
        phone: "",
        status: "",
      },
      id: "",
      pageData: "",
      tableData: [],
      multipleTable: [],
      total: 0,
      page: 1,
      pageSize: 10,
    };
  },
  mounted() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      this.getList();
    }
  },
  methods: {
    resetForm() {
      this.ruleForm.name = "";
      this.ruleForm.phone = "";
      this.ruleForm.status = "";
      this.getList();
    },
    exportList(key) {
      this.$confirm("是否导出数据", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let arr = [];
          if (this.multipleTable.length != 0) {
            for (var i = 0; i < this.multipleTable.length; i++) {
              arr.push(this.multipleTable[i].id);
            }
          }
          let param = {
            bodyguardName: this.ruleForm.name,
            phone: this.ruleForm.phone,
            workStatus: this.ruleForm.status,
            jobNo: this.id,
            ids: arr,
          };
          let str = "";
          if (key == 1) {
            str = "/admapi/job/workdetailexport";
          } else {
            str = "/admapi/job/jobsignexport";
          }
          this.$axios
            .post(str, param, { responseType: "blob" })
            .then((data) => {
              console.log(data);
              let val = new Blob([data.data], {
                type: "application/vnd.ms-excel;charset=utf-8",
              });
              let header = decodeURI(data.headers["content-disposition"]);
              console.log(header);
              let index = header.indexOf("''");
              let fileName = header.substring(index + 2, header.length);
              const url = window.URL.createObjectURL(val);
              const link = document.createElement("a");
              link.download = fileName; // 设置a标签的下载属性
              link.style.display = "none";
              link.href = url;
              document.body.appendChild(link);
              link.click();
              URL.revokeObjectURL(link.href); // 下载完成释放URL 对象
              document.body.removeChild(link);
            })
            .catch()
            .finally();
          // );
        })
        .catch(() => {});
    },
    handleSelectionChange(val) {
      this.multipleTable = val;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    goDetail1(val) {
      console.log(val);
      window.open(
        this.$router.resolve({
          path: "/attendance",
          query: {
            id: val.bodyguardId,
            jobNo: val.jobNo,
          },
        }).href,
        "_blank"
      );
    },
    getList() {
      let param = {
        page: this.page,
        pageSize: this.pageSize,
        jobNo: this.id,
      };
      if (this.ruleForm.name != "") {
        param.bodyguardName = this.ruleForm.name;
      }
      if (this.ruleForm.phone != "") {
        param.phone = this.ruleForm.phone;
      }
      this.$axios
        .post(`/admapi/job/jobworkerdetail`, param)
        .then(({ data }) => {
          this.pageData = data;
          this.tableData = data.jobWorks.items;
          this.total = data.jobWorks.page.totalRows;
        })
        .catch()
        .finally();
    },
  },
};
</script>
<style scoped>
.dis {
  display: flex;
  align-items: center;
  margin-top: 10px;
}
</style>
